import { Link } from "react-router-dom";
import { PhoneCall } from "@phosphor-icons/react";

export const COMPANY = "INPW Technologies Private Limited";
export const PRODUCT = "Inspiro Connect";
export const CONTACT_EMAIL = "support@inspiroworks.com";

const LEGAL_LINKS = [
    { to: "/privacy-policy", label: "Privacy Policy", id: "privacy" },
    { to: "/terms-of-service", label: "Terms of Service", id: "terms" },
    { to: "/data-deletion", label: "Data Deletion", id: "data-deletion" },
];

export const H2 = ({ children }) => (
    <h2 className="pt-5 font-heading text-xl font-bold tracking-tight text-ink">{children}</h2>
);
export const P = ({ children }) => <p>{children}</p>;
export const UL = ({ items }) => (
    <ul className="list-disc space-y-1.5 pl-5 marker:text-stone-400">
        {items.map((t, i) => <li key={i}>{t}</li>)}
    </ul>
);
export const Mail = () => (
    <a href={`mailto:${CONTACT_EMAIL}`} className="font-semibold text-brand hover:underline">{CONTACT_EMAIL}</a>
);

export const LegalLayout = ({ eyebrow, title, lastUpdated, testid, children }) => (
    <div className="min-h-screen bg-paper text-ink" data-testid={testid}>
        <header className="border-b border-stone-200 bg-white">
            <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
                <Link to="/login" className="flex items-center transition-opacity hover:opacity-80" data-testid="legal-home-link">
                    <img src="/inspiro-connect-logo.png" alt={PRODUCT} className="h-9 w-auto object-contain" />
                </Link>
                <Link to="/login" className="text-sm font-semibold text-stone2 transition-colors hover:text-brand" data-testid="legal-back-link">
                    Back to sign in →
                </Link>
            </div>
        </header>

        <main className="mx-auto max-w-3xl px-6 py-12 sm:py-16">
            <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-stone2">{eyebrow}</div>
            <h1 className="mt-2 font-heading text-4xl font-bold tracking-tight sm:text-5xl">{title}</h1>
            {lastUpdated && <p className="mt-3 text-sm text-stone2">Last updated: {lastUpdated}</p>}
            <div className="mt-8 space-y-4 text-[15px] leading-relaxed text-ink/90">{children}</div>
            <p className="mt-10 border-t border-stone-200 pt-6 text-sm text-stone2">
                Operated by {COMPANY}. Questions? Contact <Mail />.
            </p>
        </main>

        <footer className="border-t border-stone-200 bg-white">
            <div className="mx-auto flex max-w-3xl flex-col gap-3 px-6 py-8 text-sm text-stone2 sm:flex-row sm:items-center sm:justify-between">
                <div>© {new Date().getFullYear()} {COMPANY}. All rights reserved.</div>
                <nav className="flex flex-wrap gap-4">
                    {LEGAL_LINKS.map((l) => (
                        <Link key={l.to} to={l.to} className="font-semibold transition-colors hover:text-brand" data-testid={`footer-${l.id}-link`}>
                            {l.label}
                        </Link>
                    ))}
                </nav>
            </div>
        </footer>
    </div>
);
